import { Helmet } from "react-helmet-async";
import { Box } from "@material-ui/core";
import { LoginAuth0 } from "../../components/authentication/login";

import useAuth from "../../hooks/useAuth";

const Login = () => {
  const { platform } = useAuth();

  return (
    <>
      <Helmet>
        <title>Login | Qtravel Search Dashboard Demo</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.extra",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        {platform === "Auth0" && <LoginAuth0 />}
      </Box>
    </>
  );
};

export default Login;
